import React from "react";
// import { signIn, logOut } from '../firebase.js';
import '../Styles/index.sass';
import LoginModal from './LoginModal';
import { logOut} from '../firebase.js';
import Logo from '../Images/Home/CC_SecondaryLogo_Colour.svg';
// import { Container, Row, Col } from 'react-grid-system';
import {Nav, Navbar, Form, Button} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Styles/Navbar.sass';
// import { firestore } from '../firebase.js';
import { UserContext } from "../Providers/UserProvider";
import  { useContext } from "react";

function Header() {
  const user = useContext(UserContext);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  function openModal() {
    setModalIsOpen(true);
  }


  function closeModal() {
    setModalIsOpen(false);
  }

  return (
    <>
      <LoginModal
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
      />
        <Navbar className="nexusNav" expand="lg"  >
          <Navbar.Brand href="/"><img src={Logo}></img></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link className="navLinks" href="/findjob">Find a Job</Nav.Link>
              <Nav.Link className="navLinks"  href="/">Hire a Cleaner</Nav.Link>
            </Nav>
            <Form inline>
              <>
                {
                user === null ?
                  <>
                  <Button className="getStartedButton"  onClick={openModal}>Login</Button>
                  </> :
                  <>
                  <Nav.Link className="navLinks"  href={`/cleanerprofile/${user.uid}`}>Profile</Nav.Link>
                  <Nav.Link className="navLinks"  href="/jobform">Create Job</Nav.Link>
                  <Nav.Link className="navLinks"  href="/dashboard">Dashboard</Nav.Link>
                  <Button className="getStartedButton"  onClick={logOut}>Logout</Button>
                </>
                }
              </>
            </Form>
          </Navbar.Collapse>
        </Navbar>
      </>
  );
}

export default Header;